
function StaffBlock() {
    for (let staffBlock of document.querySelectorAll('.staff-block')) {
        let tabs = staffBlock.querySelectorAll('[role="tab"]');
        let panels = staffBlock.querySelectorAll('[role="tabpanel"]');
        let activeTab = null;
        let activePanel = null;
        for (let index = 0; index < tabs.length; index += 1) {
            let tab = tabs[index];
            let panel = panels[index];
            tab.addEventListener('click', function() {
                if (activeTab !== null && activePanel !== null) {
                    activeTab.removeAttribute('aria-selected');
                    activeTab.classList.remove('active');
                    activeTab.classList.add('inactive');
                    activePanel.setAttribute('hidden', true);
                }
                if (activeTab !== tab && activePanel !== panel) {
                    tab.setAttribute('aria-selected', 'true');
                    tab.classList.remove('inactive');
                    tab.classList.add('active');
                    panel.removeAttribute('hidden');
                    activeTab = tab;
                    activePanel = panel;
                }
                else {
                    activeTab = null;
                    activePanel = null;
                }
            });
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', StaffBlock);
}
else {
    StaffBlock();
}
